import React, { useState } from 'react'
import OfficeImg from "../assets/office2.png"
import { api } from '../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'


// organization branch join requests sent
const RequestedBranchCard = ({ b }) => {
    const [isLoading,setIsLoading] = useState(false)

     const { organization } = useParams()

      const handleRemove = async(id)=>{
        try {
            setIsLoading(true)
            const response = await api.patch(`/${organization}/branches/requests/sent`,{branch:id})
            if(response){
                setIsLoading(false)
                toast.success("branch requested removed")
            }
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response.data.message)
        }finally{setIsLoading(false)}
    }
    return (
        <div className="branch-info">
            <img src={b.logo ? b.logo : OfficeImg} alt="" />
            <div className="branch-desc">
                <h3>{b.name}</h3>
                <p>
                    {b.description
                        ? b.description.length > 50
                            ? `${b.description.substring(0, 50)}...`
                            : b.description
                        : "No description available"}
                </p>

                <button className="branch-action-card-btn" onClick={() => handleRemove(b._id)}>{!isLoading?"remove":"..."}</button>
            </div>
        </div>
    )
}

export default RequestedBranchCard